import React from 'react'
import { Stack, Skeleton as MuiSkeleton, styled } from '@mui/material'

const SenderSkeleton = styled(MuiSkeleton)`
  min-width: 40px;
  width: min(20%, 50px);
  height: 18px;
`

const DescriptorSkeleton = styled(MuiSkeleton)`
  min-width: 60px;
  width: min(30%, 80px);
  height: 16px;
`

export function MessagePreviewSkeleton() {
  return (
    <Stack justifyContent="center" sx={{ width: '100%', height: '100%' }}>
      <SenderSkeleton variant="text" />
      <DescriptorSkeleton variant="text" />
    </Stack>
  )
}
